import React from 'react';
import PropTypes from 'prop-types';
import StatisticButton from 'components/Managers/Dashboard/Views/Statistics/StatisticButton';

export default function Assessments({ value }) {
  return (
    <StatisticButton
      label="Assessments"
      value={value}
        // onClick={() => setShowModal(true)}
      className="bg-secondary-100"
    />
  );
}

Assessments.propTypes = {
  value: PropTypes.number,
};

Assessments.defaultProps = {
  value: null,
};
